import { supabase } from '../lib/supabase.js';

const listeners = new Set();
const activeJobs = new Map();
const SUPPORTED = new Set(["hugo-hu"]);
const FUNCTION_NAME = "hugo-hu-browserless";
const LABEL = "HU-GO Węgry";

function emit(message) {
  listeners.forEach(listener => {
    try { listener(message); } catch (error) { console.error(`[D24 BROWSERLESS ${LABEL}] listener:`, error); }
  });
}

async function requireSession() {
  if (!supabase) throw new Error('Brak połączenia z Supabase.');
  const { data, error } = await supabase.auth.getSession();
  if (error) throw new Error(`Nie udało się sprawdzić sesji: ${error.message}`);
  if (!data?.session?.access_token) throw new Error('Sesja wygasła. Zaloguj się ponownie.');
}

async function functionErrorMessage(error, fallback) {
  try {
    if (error?.context && typeof error.context.json === 'function') {
      const body = await error.context.json();
      if (body?.error) return body.error;
    }
  } catch {}
  return error?.message || error?.details || error?.hint || fallback;
}

export function onMessage(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export async function startJob(payload) {
  await requireSession();
  const calculatorKey = String(payload?.calculatorKey || '');
  if (!SUPPORTED.has(calculatorKey)) throw new Error(`${LABEL}: nieobsługiwany kalkulator ${calculatorKey || '(brak)'}.`);
  if (!Array.isArray(payload?.points) || payload.points.length < 2) throw new Error(`${LABEL}: potrzebne są co najmniej dwa punkty.`);
  if (payload.points.length > 10) throw new Error(`${LABEL}: ta automatyzacja obsługuje maksymalnie 10 punktów trasy.`);
  const jobId = String(payload.jobId || crypto.randomUUID());
  if (activeJobs.has(jobId)) return activeJobs.get(jobId);
  const normalizedPayload = { ...payload, jobId, requestId:jobId };

  emit({ source:'D24_BROWSERLESS_CALCULATOR', transport:'browserless', type:'JOB_ACCEPTED', payload:normalizedPayload });

  const promise = (async () => {
    emit({ source:'D24_BROWSERLESS_CALCULATOR', transport:'browserless', type:'JOB_STATUS', payload:{ ...normalizedPayload, status:'processing' } });
    const { data, error } = await supabase.functions.invoke(FUNCTION_NAME, { body:normalizedPayload });
    if (error) throw new Error(await functionErrorMessage(error, `Edge Function ${FUNCTION_NAME} zakończyła się błędem.`));
    if (!data?.ok || !data?.result) throw new Error(data?.error || `${LABEL} nie zwrócił wyniku.`);
    const result = { ...normalizedPayload, ...data.result, jobId, requestId:jobId, source:'browserless', cloudGuardrail:data.guardrail || null };
    emit({ source:'D24_BROWSERLESS_CALCULATOR', transport:'browserless', type:'CALCULATOR_RESULT', payload:result });
    return result;
  })().catch(error => {
    emit({ source:'D24_BROWSERLESS_CALCULATOR', transport:'browserless', type:'JOB_ERROR', payload:normalizedPayload, error:error?.message || String(error) });
    throw error;
  }).finally(() => activeJobs.delete(jobId));

  activeJobs.set(jobId, promise);
  return promise;
}
